export type PriceFormatOptions = {
  locale?: string
  currency?: string
  minimumFractionDigits?: number
  maximumFractionDigits?: number
}

export type PriceParts = {
  amount: number | null
  isContact: boolean
}

export function formatCurrency(amount: number, options: PriceFormatOptions = {}): string {
  const {
    locale = typeof document !== "undefined" ? document.documentElement.lang || "en" : "en",
    minimumFractionDigits = 0,
    maximumFractionDigits = 0,
  } = options

  try {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(amount)
  } catch {
    return `${amount}`
  }
}

export function parsePriceOverview(input: string | number): PriceParts {
  if (typeof input === "number") {
    return { amount: input, isContact: false }
  }

  if (typeof input !== "string" || input.trim() === "") {
    return { amount: null, isContact: false }
  }

  const lower = input.toLowerCase()
  if (lower.includes("contact") || lower.includes("request") || lower.includes("inquiry")) {
    return { amount: null, isContact: true }
  }

  const [amountPartRaw, unitPartRaw] = input.split("/")
  const match = amountPartRaw?.match(/\d+(?:\.\d+)?/)
  const amount = match ? Number(match[0]) : null
  return { amount: Number.isFinite(amount) ? (amount as number) : null, isContact: false }
}

export function getFormattedPriceParts(
  input: string | number,
  options?: PriceFormatOptions,
): { priceMain: string; isContact: boolean } {
  const { amount, isContact } = parsePriceOverview(input)

  if (isContact) {
    return { priceMain: String(input), isContact }
  }

  if (amount === null) {
    return { priceMain: String(input), isContact: false }
  }

  const formatted = formatCurrency(amount, options)
  return { priceMain: formatted, isContact: false }
}


